import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import React from 'react';
import clsx from 'clsx';
import { StatusBadge } from '../../../components/status/StatusBadge';
import { ColumnSizing } from '../tables-context';
import { IPartnerList } from '../../merchnts/merchant-interfaces';

export interface IPreparedAccountData {
	id: string,
	partnerName: string,
	contactName: string,
	email: string,
	phone: string,
	status: boolean,
	data: IPartnerList
}

export enum AccountTableAccessorKey {
	id = 'id',
	partnerName = 'partnerName',
	contactName = 'contactName',
	email = 'email',
	phone = 'phone',
	status = 'status'
}

export const defaultAccountColumnSizing: ColumnSizing = {
	[AccountTableAccessorKey.id]: 200,
	[AccountTableAccessorKey.partnerName]: 150,
	[AccountTableAccessorKey.contactName]: 150,
	[AccountTableAccessorKey.email]: 200,
	[AccountTableAccessorKey.phone]: 100,
	[AccountTableAccessorKey.status]: 70,
};

export const defaultAccountColumns: MRT_ColumnDef<IPreparedAccountData>[] = [
	{
		accessorKey: AccountTableAccessorKey.id,
		header: 'Id',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Id</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fw-bolder fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: AccountTableAccessorKey.partnerName,
		header: 'Account name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Account name</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: AccountTableAccessorKey.contactName,
		header: 'Contact name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Contact name</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: AccountTableAccessorKey.email,
		header: 'Email',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Email</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: AccountTableAccessorKey.phone,
		header: 'Phone',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Phone</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: AccountTableAccessorKey.status,
		header: 'Status',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Status</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fw-bolder fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<StatusBadge
					status={renderedCellValue ? 'Active' : 'Pending'}
					additionalClasses={clsx(!renderedCellValue && 'text-dark')}
				/>
			</TableCell>
		)
	},
];
